import "./report.css";
import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
import { useCompany } from "../../components/context/CompanyContext";
import { userRequest } from "../../requestMethods";
import dayjs from "dayjs";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import catalogo from "../../icons/catalogo.svg";
import cliente from "../../icons/cliente.svg";
import cadastro from "../../icons/cadastro.svg";
import CustomGrid from "../../components/grid/CustomGrid";
import { formatTimeDDMMYYY } from "../../util/helper";

export default function MidiaReport() {
  const dispatch = useDispatch();
  const { midiaReport, companyId } = useCompany();
  const [urlMidia, setUrlMidia] = useState(null);

  const [readonly, setReadonly] = useState("30");
  const [dataIni, setDataIni] = useState(
    dayjs(new Date()).add(-30, "day").format("YYYY-MM-DD"),
  );
  const [dataFim, setDataFim] = useState(
    dayjs(new Date()).format("YYYY-MM-DD"),
  );
  const [utmBreakdown, setUtmBreakdown] = useState(null);
  const [traffic, setTraffic] = useState(null);
  const [analitico, setAnalitico] = useState([]);
  const analiticoRef = useRef(null);

  dispatch(titleSetRef({ title: "Midia" }));

  useEffect(() => {
    if (midiaReport) {
      setUrlMidia(`https://app.reportei.com/embed/${midiaReport}`);
    } else {
      setUrlMidia(null);
    }
  }, [midiaReport]);

  useEffect(() => {
    if (companyId > 0 && dataIni && dataFim) {
      const body = { start: dataIni, end: dataFim };
      userRequest
        .post(`${companyId}/reportCustomer/utmBreakdown`, body)
        .then((res) => setUtmBreakdown(res.data))
        .catch(() => {});
      userRequest
        .post(`${companyId}/reportCustomer/customersAcess`, body)
        .then((res) => setTraffic(res.data))
        .catch(() => {});
      setAnalitico([]);
    }
  }, [companyId, dataIni, dataFim]);

  const handleChange = (e) => {
    const val = e.target.value;
    setReadonly(val);
    if (val !== "F") {
      setDataIni(
        dayjs(new Date()).add(-Number(val), "day").format("YYYY-MM-DD"),
      );
      setDataFim(dayjs(new Date()).format("YYYY-MM-DD"));
    }
  };

  const fetchAnalitico = async (typeAcess) => {
    try {
      const res = await userRequest.post(
        `${companyId}/reportCustomer/customersAnaliticoAcess`,
        { start: dataIni, end: dataFim, typeAcess },
      );
      setAnalitico(res.data);
      setTimeout(() => {
        analiticoRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } catch {}
  };

  const _voltarTopo = () => {
    window.scrollTo(0, 0);
  };

  const periodLabel =
    readonly === "F"
      ? "Exibindo dados do filtro de data"
      : readonly === "0"
        ? "Exibindo dados de hoje"
        : `Exibindo dados dos últimos ${readonly} dias`;

  const hasUtmData =
    utmBreakdown &&
    (utmBreakdown.bySource?.length > 0 ||
      utmBreakdown.byCampaign?.length > 0 ||
      utmBreakdown.byMedium?.length > 0);

  const columnsAnalitico = [
    { field: "name", headerName: "Nome", width: 200 },
    { field: "contact", headerName: "Contato", width: 160 },
    { field: "cnpj_cpf", headerName: "CNPJ", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    {
      field: "createdAt",
      headerName: "Criado",
      width: 120,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
    },
    { field: "managedBy", headerName: "Vendedor(a)", width: 180 },
    { field: "utmSource", headerName: "UTM Source", width: 120 },
    { field: "utmCampaign", headerName: "UTM Campaign", width: 150 },
    { field: "utmMedium", headerName: "UTM Medium", width: 120 },
  ];

  return (
    <div className="div_home_Container">
      {/* Filtro de período */}
      <div>
        <div className="datePicker">
          <label className="labelPeriodo">
            Filtrar:
            <input
              type="date"
              value={dataIni}
              min="2023-01-01"
              onChange={(e) => setDataIni(e.target.value)}
              disabled={readonly !== "F"}
            />
            <input
              type="date"
              value={dataFim}
              min="2023-01-01"
              onChange={(e) => setDataFim(e.target.value)}
              disabled={readonly !== "F"}
            />
          </label>
        </div>
        <div className="column">
          <input
            type="radio"
            value="30"
            onChange={handleChange}
            checked={readonly === "30"}
          />
          <label>30 dias</label>
          <input
            type="radio"
            value="15"
            onChange={handleChange}
            checked={readonly === "15"}
          />
          <label>15 dias</label>
          <input
            type="radio"
            value="7"
            onChange={handleChange}
            checked={readonly === "7"}
          />
          <label>7 dias</label>
          <input
            type="radio"
            value="0"
            onChange={handleChange}
            checked={readonly === "0"}
          />
          <label>Hoje</label>
          <input
            type="radio"
            value="F"
            onChange={handleChange}
            checked={readonly === "F"}
          />
          <label>Filtro</label>
        </div>
      </div>

      <table width="100%" className="tableSpaceTab">
        {/* Card Tráfego pago - painel de contadores */}
        <tr>
          <div className="div_home_custom">
            <table className="table">
              <tr>
                <td align="left" width="100%">
                  <tr>
                    <td>
                      <img src={cliente} alt="" />
                    </td>
                    <td>
                      <tr className="labelTitle">Tráfego pago</tr>
                      <tr className="labelMsgData">{periodLabel}</tr>
                    </td>
                  </tr>
                </td>
                <td align="left" width="0%">
                  {" "}
                </td>
              </tr>
            </table>

            <table className="table_painel">
              <tr>
                <td width="20%" className="status_painel">
                  Leads<span className="labelMsgDataAtivos"> (anônimos)</span>
                </td>
                <td width="20%" className="status_painel">
                  Total
                  <span className="labelMsgDataAtivos"> (cadastrados)</span>
                </td>
                <td width="20%" className="status_painel">
                  Pendentes
                </td>
                <td width="20%" className="status_painel">
                  Aprovados
                </td>
                <td width="20%" className="status_painel">
                  Recusados
                </td>
              </tr>
              <tr>
                <td className="labelValue_painel_black">
                  {traffic?.trafficLead ?? 0}
                </td>
                <td
                  className="labelValue_painel_black"
                  onClick={() => fetchAnalitico("totalTrafficAcess")}
                >
                  {traffic?.trafficTotal ?? 0}
                </td>
                <td
                  className="labelValue_painel_black"
                  onClick={() => fetchAnalitico("trafficPend")}
                >
                  {traffic?.trafficPend ?? 0}
                </td>
                <td
                  className="labelValue_painel_black"
                  onClick={() => fetchAnalitico("trafficAcess")}
                >
                  {traffic?.trafficAcess ?? 0}
                </td>
                <td
                  className="labelValue_painel_black"
                  onClick={() => fetchAnalitico("trafficNAcess")}
                >
                  {traffic?.trafficNAcess ?? 0}
                </td>
              </tr>
            </table>
          </div>
        </tr>

        {/* Card UTM por fonte / campanha / mídia */}
        <tr>
          <div className="div_home_custom">
            <table className="table">
              <tr>
                <td align="left" width="100%">
                  <tr>
                    <td>
                      <img src={catalogo} alt="" />
                    </td>
                    <td>
                      <tr className="labelTitle">Tráfego Pago — Origem UTM</tr>
                      <tr className="labelMsgData">{periodLabel}</tr>
                    </td>
                  </tr>
                </td>
              </tr>
            </table>

            {utmBreakdown && !hasUtmData && (
              <div style={{ padding: "16px", color: "#999" }}>
                Nenhum dado de UTM no período selecionado.
              </div>
            )}

            {utmBreakdown?.bySource?.length > 0 && (
              <>
                <div className="labelTitle" style={{ padding: "12px 0 4px" }}>
                  Por fonte (utm_source)
                </div>
                <ResponsiveContainer width="95%" height={220}>
                  <BarChart data={utmBreakdown.bySource}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      tick={{ fontSize: 12 }}
                      interval={0}
                      angle={-20}
                    />
                    <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
                    <Tooltip />
                    <Bar
                      dataKey="count"
                      name="Visitas"
                      fill="#EE8253"
                      barSize={20}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </>
            )}

            {utmBreakdown?.byCampaign?.length > 0 && (
              <>
                <div className="labelTitle" style={{ padding: "12px 0 4px" }}>
                  Por campanha (utm_campaign)
                </div>
                <ResponsiveContainer width="95%" height={220}>
                  <BarChart data={utmBreakdown.byCampaign}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      tick={{ fontSize: 12 }}
                      interval={0}
                      angle={-20}
                    />
                    <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
                    <Tooltip />
                    <Bar
                      dataKey="count"
                      name="Visitas"
                      fill="#5b8dee"
                      barSize={20}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </>
            )}

            {utmBreakdown?.byMedium?.length > 0 && (
              <>
                <div className="labelTitle" style={{ padding: "12px 0 4px" }}>
                  Por mídia (utm_medium)
                </div>
                <ResponsiveContainer width="95%" height={220}>
                  <BarChart data={utmBreakdown.byMedium}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      tick={{ fontSize: 12 }}
                      interval={0}
                      angle={-20}
                    />
                    <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
                    <Tooltip />
                    <Bar
                      dataKey="count"
                      name="Visitas"
                      fill="#52c41a"
                      barSize={20}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </>
            )}
          </div>
        </tr>

        {/* Card Analítico */}
        <tr>
          <div className="div_home_custom" ref={analiticoRef}>
            <table className="table">
              <tr>
                <td align="left" width="100%">
                  <tr>
                    <td>
                      <img src={cadastro} alt="" />
                    </td>
                    <td>
                      <tr className="labelTitle">Analítico clientes</tr>
                    </td>
                  </tr>
                </td>
                <td align="left" width="0%">
                  {" "}
                </td>
              </tr>
            </table>
            <div
              className="div_custom_UpdateItem full-width"
              style={{ height: 350, width: "100%" }}
            >
              <CustomGrid
                gridId="analiticomidialist"
                rows={analitico}
                columns={columnsAnalitico}
                pageSize={45}
                checkboxSelection={false}
              />
            </div>
          </div>
        </tr>

        {/* iframe Reportei */}
        {midiaReport && (
          <tr>
            <div className="div_home_custom">
              <table className="table">
                <tr>
                  <td align="left" width="100%">
                    <tr>
                      <td>
                        <img src={catalogo} alt="" />
                      </td>
                      <td>
                        <tr className="labelTitle">Relatório de Mídia</tr>
                        <tr className="labelMsgData">Reportei</tr>
                      </td>
                    </tr>
                  </td>
                </tr>
              </table>
              <iframe
                src={urlMidia}
                title="Midia"
                style={{ width: "100%", height: "100vh", border: "none" }}
              />
            </div>
          </tr>
        )}

        {!midiaReport && (
          <tr>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "40vh",
                textAlign: "center",
              }}
            >
              <h1
                style={{
                  fontSize: "2rem",
                  color: "#333",
                  marginBottom: "10px",
                }}
              >
                Acesso ao midia indisponível
              </h1>
              <p
                style={{ fontSize: "1.2rem", color: "#555", maxWidth: "400px" }}
              >
                Entre em contato com o administrador para obter acesso.
              </p>
            </div>
          </tr>
        )}
      </table>

      <div className="divRodape" onClick={_voltarTopo}>
        voltar ao topo
      </div>
    </div>
  );
}
